// extracted by mini-css-extract-plugin
module.exports = {"button":"a7889b56a06456f9631375452734e915","text":"efd179b8ece684eeda0934d7b40869b6"};